import { useAxiosInstances } from "../axios-instance"

export const useLoginApi = () => {
  const { axiosInstance } = useAxiosInstances()
  
  const signInApi = (data: {
    email: string
    password: string
    domain: string
  }): Promise<{
    token: string
    requiresTwoFactor?: boolean
    tempToken?: string
    requiresTwoFactorActivation?: boolean
    userId?: string
    message?: string
  }>=> {
    return axiosInstance.post('/routes/authentication/sign-in', data).then((res) => {
      return {
        userId: res.data.result.userId,
        token: res.data.result.token,
        requiresTwoFactor: res.data.result.requiresTwoFactor,
        tempToken: res.data.result.tempToken,
        requiresTwoFactorActivation: res.data.result.requiresTwoFactorActivation,
        message: res.data.result.message
      }
      
    }).catch((error) => {
      const data = error?.response?.data;
      if (data) {
        throw {
          message: data.result?.message || data.error?.message || data.message || 'Erro desconhecido',
          type: data.result?.type || data.error?.type || 'unknown'
        }
      } else {
        throw {
          message: 'Erro desconhecido',
          type: 'unknown'
        }
      }
    })
  }

  return {
    signInApi
  }
}